import { render, staticRenderFns } from "./NaturalnessSetting.vue?vue&type=template&id=3e6cb8f0"
import script from "./NaturalnessSetting.vue?vue&type=script&lang=js"
export * from "./NaturalnessSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports